// This file is auto-generated during build. Do not edit manually.
export const SDK_VERSION = '0.5.2' as const
